import { Button } from "@/components/ui/baseUi/button"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/baseUi/carousel"
import { Text } from "@/components/ui/baseUi/text"
import type { MediaItemFormType } from "@/modules/common/media/mediaFormTypes"
import { word } from "@modules/core/utils/i18n"
import { HUImageForm } from "@modules/ui/components/huImageForm"
import { removeInArray } from "@modules/utils/objectUtils"
import { TrashIcon } from "lucide-react"
import { useState } from "react"

type BoxPhotosFormProps = {
  boxPhotos: MediaItemFormType[]
  setBoxPhotos: (photos: MediaItemFormType[]) => void
  setIsImageUploading?: (isImageUploading: boolean) => void
} & React.ComponentProps<"div">

export function BoxPhotosForm({ boxPhotos, setBoxPhotos, setIsImageUploading, ...props }: BoxPhotosFormProps) {
  const [_page, setPage] = useState(0)

  const carouselItemTemplate = (image: MediaItemFormType) => {
    const urlImage = image.file ? URL.createObjectURL(image.file) : (image.url ?? undefined)

    return (
      <div className="m-1 flex flex-col items-center rounded-lg py-5 text-center">
        <div className="mb-3 flex h-full">
          <img
            src={urlImage}
            alt=""
            className="h-full max-h-[300px] w-full max-w-[300px] rounded-lg object-cover shadow-lg"
          />
        </div>
        <div>
          <div className="mt-5">
            <Button
              variant="outline"
              size="iconMd"
              onClick={() => {
                const index = boxPhotos.findIndex((i) => i.url === urlImage)
                setBoxPhotos([...removeInArray(boxPhotos, index)])
              }}
            >
              <TrashIcon />
            </Button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div {...props}>
      <Text fontStyle="LL">{word("box.form.additionalImage.label")}</Text>
      <div className="flex flex-col pt-3">
        {!!boxPhotos.length && (
          <Carousel className="mx-auto w-7/10" opts={{ align: "start", loop: false }}>
            <CarouselContent>
              {boxPhotos.map((item: MediaItemFormType, index: number) => (
                <CarouselItem className="w-full" key={index}>
                  {carouselItemTemplate(item)}
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious />
            <CarouselNext />
          </Carousel>
        )}

        {boxPhotos.length < 5 && (
          <HUImageForm
            type="cover"
            image={null}
            placeHolder={{
              message: word("box.form.uploadImage.text1"),
            }}
            setIsImageUploading={setIsImageUploading}
            setImage={(image?: MediaItemFormType) => {
              if (image) {
                setBoxPhotos([...boxPhotos, image])
                setPage(boxPhotos.length)
              }
            }}
          />
        )}
      </div>
    </div>
  )
}
